import React from "react";
import InformationTaskFactory from "./AssessmentInfoSlideControls/InformationTaskFactory";

interface TaskStepProps {
  topContentRef: React.RefObject<HTMLDivElement>;
  slideKey: string;
  domain: string;
  questionCompleter: any
}

const TaskInformationStep: React.FC<TaskStepProps> = (props) => {
  const { slideKey, domain, questionCompleter, topContentRef } = props;

  return (
    <InformationTaskFactory
      topContentRef={topContentRef}
      slideKey={slideKey}
      domain={domain}
      questionCompleter={questionCompleter}
    />
  );
};

export default TaskInformationStep;
